import { useQuery } from '@tanstack/react-query';
import clsx from 'clsx';
import { Badge, Card, ErrorState, PageHeader, ProgressBar, Spinner } from '../components/ui';
import { api, qk } from '../lib/api';

export function AchievementsPage() {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: qk.achievements,
    queryFn: () => api.listAchievements(),
  });

  if (isLoading) return <Spinner label="Амжилтуудыг ачаалж байна…" />;
  if (error) return <ErrorState error={error} onRetry={() => void refetch()} />;
  if (!data) return null;

  const unlocked = data.filter((achievement) => achievement.unlockedAt !== null);

  return (
    <>
      <PageHeader
        title="Амжилтууд"
        description={`${data.length}-аас ${unlocked.length}-г нээсэн · бичилт бүрийн дараа автоматаар шалгагдана`}
      />

      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
        {data.map((achievement) => {
          const isUnlocked = achievement.unlockedAt !== null;
          return (
            <Card
              key={achievement.id}
              className={clsx(!isUnlocked && 'opacity-70')}
              bodyClassName="p-4"
            >
              <div className="flex items-start gap-3">
                <span
                  className={clsx(
                    'flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-2xl',
                    isUnlocked ? 'bg-accent/15' : 'bg-raised grayscale',
                  )}
                  aria-hidden
                >
                  {achievement.icon}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-start justify-between gap-2">
                    <p className="text-sm font-medium">{achievement.name}</p>
                    {isUnlocked ? (
                      <Badge tone="success">Нээгдсэн</Badge>
                    ) : (
                      <Badge>{Math.round(achievement.progress * 100)}%</Badge>
                    )}
                  </div>
                  <p className="mt-0.5 text-xs text-muted">{achievement.description}</p>

                  <div className="mt-3">
                    <ProgressBar value={achievement.progress} />
                    <p className="mt-1.5 text-xs text-muted">
                      {isUnlocked
                        ? `Нээсэн ${achievement.unlockedAt?.slice(0, 10)}`
                        : achievement.progressLabel}
                    </p>
                  </div>
                </div>
              </div>
            </Card>
          );
        })}
      </div>
    </>
  );
}
